// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.maintenance-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  /* background: #f8f9fa; */
  /* padding: 24px; */
}

.maintenance-img {
  width: 80vw;
  max-width: 500px;
  height: auto;
  object-fit: contain;
  margin-bottom: 32px;
  /* box-shadow: 0 2px 16px rgba(0,0,0,0.08);
  border-radius: 16px; */
}

.maintenance-title {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 12px;
  color: #222;
}

.maintenance-message {
  font-size: 1.2rem;
  color: #555;
  text-align: center;
  max-width: 500px;
} `, "",{"version":3,"sources":["webpack://./src/views/pages/Maintenance.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB;wBACsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".maintenance-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  /* background: #f8f9fa; */\n  /* padding: 24px; */\n}\n\n.maintenance-img {\n  width: 80vw;\n  max-width: 500px;\n  height: auto;\n  object-fit: contain;\n  margin-bottom: 32px;\n  /* box-shadow: 0 2px 16px rgba(0,0,0,0.08);\n  border-radius: 16px; */\n}\n\n.maintenance-title {\n  font-size: 2rem;\n  font-weight: 700;\n  margin-bottom: 12px;\n  color: #222;\n}\n\n.maintenance-message {\n  font-size: 1.2rem;\n  color: #555;\n  text-align: center;\n  max-width: 500px;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
